import React from 'react';
import Grid, { GridItem } from '@marvelapp/marvel-ui/grid';
import PageWrap from '@marvelapp/marvel-ui/page-wrap';
import Spacing from '@marvelapp/marvel-ui/spacing';

import HeadingBlock from 'marketing-website/components/modules/HeadingBlock';
import HandoffArtwork from 'marketing-website/components/modules/HandoffArtwork';

export default function Sync() {
  return (
    <PageWrap size="l">
      <Spacing sizeM="xl" type="padding" position="topBottom">
        <Grid columns={12} alignItems="center">
          <GridItem columnSpan={12} columnSpanM={6}>
            <HandoffArtwork />
          </GridItem>
          <GridItem columnSpan={12} columnSpanM={6}>
            <Spacing sizeM="xl" type="padding" position="left">
              <HeadingBlock
                justifyContent="center"
                justifyM="start"
                maxWidth={400}
                title="Always in sync with the latest design changes"
                copy={
                  <span>
                    With Marvel, all your work is updated in real time.
                    <br />
                    <br />
                    Collaborator's design changes are synced automatically, so
                    all the code, specs and assets generated in our UI handoff
                    tool will always be the latest and correct version. No
                    miscommunication, no madness.
                  </span>
                }
              />
            </Spacing>
          </GridItem>
        </Grid>
      </Spacing>
    </PageWrap>
  );
}



// WEBPACK FOOTER //
// ./src/pages/features/handoff/Sync.js